import { isNotProduction } from './isNotProduction';
import dayjs from 'dayjs';

export const SHIFTED_DATETIME = 'shiftedDateTime';

export const removeShiftedDatetime = () => {
  return sessionStorage.removeItem(SHIFTED_DATETIME);
};

export const getShiftedDatetime = () => {
  return sessionStorage.getItem(SHIFTED_DATETIME) || undefined;
};

export const setShiftedDatetime = (day: string) => {
  const newDate = `${day} 00:00:00:000`;
  sessionStorage.setItem(SHIFTED_DATETIME, newDate);
};

// Returns a `time` header for non-production environments to override the server date during testing
export const getShiftedDatetimeHeader = (): { time?: string } | {} => {
  const timeFromSession = getShiftedDatetime();
  if (!isNotProduction() || !timeFromSession) return {};
  return {
    time: timeFromSession,
  };
};

// Returns the "current" date, respecting any QA-shifted datetime stored in sessionStorage
export const getToday = (valueFromParent?: string) => {
  if (valueFromParent) return new Date(valueFromParent);

  const shiftedDate = getShiftedDatetime();
  if (shiftedDate) return new Date(shiftedDate);
  return new Date();
};

// Compares a given date against today using day-level granularity (ignores time component)
export const compareDateWithToday = (
  date: Date | string | undefined = '',
  operator: '<' | '>' | '<=' | '>=',
): boolean => {
  const todayDate = dayjs(getToday());
  const secondDate = dayjs(typeof date === 'string' ? new Date(date) : date);

  const operators = {
    '<': secondDate.isBefore(todayDate, 'day'),
    '>': secondDate.isAfter(todayDate, 'day'),
    '<=':
      secondDate.isBefore(todayDate, 'day') ||
      secondDate.isSame(todayDate, 'day'),
    '>=':
      secondDate.isAfter(todayDate, 'day') ||
      secondDate.isSame(todayDate, 'day'),
  };

  return operators[operator];
};
